import type { TownsquareProject } from '../../types';

export const isTownsquareProject = (entity: any): entity is TownsquareProject =>
	entity.__typename === 'TownsquareProject';

export const getTownsquareProjectLink = (project: TownsquareProject): string | null =>
	project?.url ?? null;
